import React, { PropsWithChildren, useEffect } from 'react';
import { I18nProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { setComponentLibraryLang } from '@ygtechnologies/bygr-frontend-component-library';
import { CultureInfo } from '@/utils/localization';

interface I18nLoaderProps extends PropsWithChildren {
    language: CultureInfo;
}

export async function dynamicActivate(locale: string) {
    const { messages } = await import(`../../locales/${locale}/messages.mjs`);
    i18n.load(locale, messages);
    i18n.activate(locale);

    if (window.document && window.document.body) {
        window.document.body.dir = locale === 'he' ? 'rtl' : 'ltr';
    }
}

const I18nLoader: React.FC<I18nLoaderProps> = ({ language, children }) => {
    useEffect(() => {
        dynamicActivate(language.languageCode);
        setComponentLibraryLang(language.locale);
    }, [language]);
    return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
};
export default I18nLoader;
